import React from "react";
import svg78 from "../../assets/svg/svg78.svg";
import svg79 from "../../assets/svg/svg79.svg";
import svg80 from "../../assets/svg/svg80.svg";
import svg81 from "../../assets/svg/svg81.svg";
import svg82 from "../../assets/svg/svg82.svg";
import svg140 from "../../assets/svg/svg140.svg";
import svg141 from "../../assets/svg/svg141.svg";
import svg142 from "../../assets/svg/svg142.svg";
import svg143 from "../../assets/svg/svg143.svg";

function Partners() {
  const partners = [
    { id: 1, logo: svg78, alt: "Partner 1" },
    { id: 2, logo: svg79, alt: "Partner 2" },
    { id: 3, logo: svg80, alt: "Partner 3" },
    { id: 4, logo: svg81, alt: "Partner 4" },
    { id: 5, logo: svg82, alt: "Partner 5" },
    { id: 6, logo: svg140, alt: "Partner 6" },
    { id: 7, logo: svg141, alt: "Partner 7" },
    { id: 8, logo: svg142, alt: "Partner 8" },
    { id: 9, logo: svg143, alt: "Partner 9" },
  ];

  return (
    <div className="flex flex-col items-center text-center justify-center py-12 overflow-hidden">
      <div className="text-ink text-[2.25rem] font-[400] leading-[2.625rem] mb-2">
        Powering Businesses Across Industries
      </div>
      <div className="text-body text-[1.25rem] font-[400] leading-[1.625rem] mb-12">
        Trusted by Businesses Across Kenya
      </div>

      <div className="partners-scroll-container">
        <div className="partners-scroll-track">
          {partners?.map((partner) => (
            <div key={`original-${partner?.id}`} className="partner-logo-item">
              <img
                src={partner?.logo}
                alt={partner?.alt}
                className="partner-logo w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:!w-[8.125rem] lg:!h-[8.125rem] !object-contain"
              />
            </div>
          ))}
          {partners?.map((partner) => (
            <div key={`duplicate-${partner?.id}`} className="partner-logo-item">
              <img
                src={partner?.logo}
                alt={partner?.alt}
                className="partner-logo w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:!w-[8.125rem] lg:!h-[8.125rem] !object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Partners;
